<div class="modal-body text-center" *ngIf="isInitialized">
  <div class="mb-4" [hidden]="bagsSelected && !expandBagPicker">
    <div class="bags-header">{{ 'HOW_MANY_BAGS_DROP_OFF' | translate }}</div>
    <lh-bag-selector [(ngModel)]="numberOfBags" [(bagsSelected)]="bagsSelected"></lh-bag-selector>
  </div>

  <div *ngIf="bagsSelected && !expandBagPicker">
    <div class="bags-header">
      {{ 'YOU_ARE_DROPPING_OFF_NO_BAGS' | translate }} {{ numberOfBags }}
      {{ (numberOfBags === 1 ? 'BAG' : 'BAGS') | translate | lowercase }}
      <a class="href" *ngIf="!expandBagPicker" (click)="expandBagPicker = true">
        {{ 'CHANGE' | translate }}
      </a>
    </div>
  </div>

  <lh-shared-feature-bag-image-input
    [remoteImage]="remoteLuggageImage"
    [storageLocation]="shop"
    [booking]="booking"
    [numberOfBags]="numberOfBags"
    (completedChange)="onBagPhotoCompletedChange($event)"
    (allowSkipChange)="onAllowSkipBagPhotoChange($event)"
    *ngIf="bagsSelected"
  ></lh-shared-feature-bag-image-input>

  <div *ngIf="bagsSelected">
    <div *ngIf="!isBagPhotoCompleted" class="photo-explanation">
      <span class="text-warning">{{ 'IMPORTANT_COLON' | translate | uppercase }}</span>
      <span *ngIf="!isLuggageImageRequired" class="ms-1">{{ 'PHOTO_OF_LUGGAGE_RECOMMENDED' | translate }}</span>
      <span *ngIf="isLuggageImageRequired" class="ms-1">{{ 'TAKE_A_PHOTO_OF_YOUR_LUGGAGE' | translate }}</span>
    </div>
    <div *ngIf="isBagPhotoCompleted" class="photo-explanation">
      <span class="text-success">{{ 'YOURE_ALL_SET' | translate }}</span>
      {{ 'START_TIMER_AND_HAND_OVER_LUGGAGE_AT' | translate }} {{ booking.shopName }}
    </div>
  </div>
</div>

<div class="modal-footer">
  <!-- Storage timer -->
  <div class="timer-wrapper" *ngIf="isStorageTimerEnabled">
    <lh-storage-timer
      [booking]="booking"
      [isCheckInSession]="false"
      [compactMode]="true"
      [largeDigits]="true"
    ></lh-storage-timer>
  </div>

  <lh-shared-ui-confirm-button
    class="align-self-stretch"
    id="confirmCheckIn"
    [slideCallToAction]="'SLIDE_TO_CONFIRM_DROPOFF' | translate"
    [clickCallToAction]="'CONFIRM_DROPOFF' | translate"
    (confirm)="checkIn()"
    [mode]="'primary'"
    [disabled]="!isCheckinAllowed"
    [isLoading]="isLoading"
    *ngIf="isSlideToConfirmEnabled"
  >
  </lh-shared-ui-confirm-button>

  <div *ngIf="!isSlideToConfirmEnabled">
    <button
      id="confirmCheckIn"
      type="button"
      (click)="checkIn()"
      [disabled]="!isCheckinAllowed"
      class="btn btn-block btn-primary lh-btn"
    >
      {{ 'START_STORAGE_TIMER' | translate }}
    </button>

    <button
      id="abortCheckIn"
      type="button"
      (click)="close()"
      [disabled]="isLoading"
      class="btn btn-link btn-block lh-btn"
    >
      <span>{{ 'CANCEL' | translate }}</span>
    </button>
  </div>
</div>
